import React from 'react';
import PostIcon from '../../../assets/icons/PostIcon';
import ReelIcon from '../../../assets/icons/ReelIcon';
import StoriesIcon from '../../../assets/icons/StoriesIcon';
import { PostType } from './types';
import styles from '../../../styles/usageRights.module.css';
import VideoIcon from '../../../assets/icons/VideoIcon';

const tagMap = {
  post: { text: 'Post', logo: <PostIcon color="var(--icon-subdued)" /> },
  reel: { text: 'Reel', logo: <ReelIcon color="var(--icon-subdued)" /> },
  story: { text: 'Story', logo: <StoriesIcon color="var(--icon-subdued)" /> },
  video: { text: 'Video', logo: <VideoIcon color="var(--icon-subdued)" /> },
};

interface TypeTagProps {
  type: PostType;
}

function TypeTag({ type }: TypeTagProps) {
  return (
    <div className={styles.postTypeTag}>
      {tagMap[type].logo} {tagMap[type].text}
    </div>
  );
}

export default TypeTag;
